import React, { useState } from 'react';
import styled from 'styled-components';

const Card = styled.div`
  background: #1a1a1a;
  border: 1px solid #333;
  border-radius: 12px;
  padding: 20px;
  text-align: center;
`;

const Title = styled.h3`
  color: #a78bfa;
  font-size: 14px;
  font-weight: 700;
  margin: 0 0 6px 0;
  letter-spacing: 0.05em;
  text-transform: uppercase;
`;

const Sub = styled.p`
  color: #9ca3af;
  font-size: 13px;
  margin: 0 0 16px 0;
`;

const Stars = styled.div`
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-bottom: 16px;
`;

const Star = styled.button`
  background: none;
  border: none;
  font-size: 32px;
  cursor: pointer;
  transition: transform 0.15s;
  line-height: 1;

  &:hover { transform: scale(1.2); }
`;

const SajuQuestion = styled.div`
  margin-top: 16px;
  padding: 14px;
  background: #111827;
  border: 1px solid #374151;
  border-radius: 10px;
`;

const SajuQuestionText = styled.div`
  color: #d1d5db;
  font-size: 13px;
  margin-bottom: 12px;
`;

const BtnRow = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
`;

const YesNoBtn = styled.button`
  padding: 8px 20px;
  background: ${({ $active }) => $active ? '#4c1d95' : '#1f2937'};
  border: 1px solid ${({ $active }) => $active ? '#7c3aed' : '#374151'};
  border-radius: 8px;
  color: ${({ $active }) => $active ? '#c4b5fd' : '#9ca3af'};
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;

  &:hover {
    background: #4c1d95;
    border-color: #7c3aed;
    color: #c4b5fd;
  }
`;

const ThankMsg = styled.div`
  color: #a78bfa;
  font-size: 14px;
  font-weight: 600;
`;

const AgainBtn = styled.button`
  margin-top: 16px;
  padding: 10px 24px;
  background: linear-gradient(135deg, #7c3aed, #5b21b6);
  border: none;
  border-radius: 10px;
  color: white;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  &:hover { opacity: 0.9; }
`;

export default function FeedbackWidget({ onFeedback, onReset, hasSaju }) {
  const [selected, setSelected] = useState(0);
  const [hover, setHover] = useState(0);
  const [scoreSubmitted, setScoreSubmitted] = useState(false);
  const [sajuHelped, setSajuHelped] = useState(null);

  const handleSelect = async (score) => {
    setSelected(score);
    setScoreSubmitted(true);
    if (!hasSaju) {
      await onFeedback(score, undefined);
    }
    // hasSaju인 경우 사주 도움 질문 표시 후 onFeedback 호출
  };

  const handleSajuHelped = async (helped) => {
    setSajuHelped(helped);
    await onFeedback(selected, helped);
  };

  return (
    <Card>
      <Title>Step 6 — 피드백</Title>

      {!scoreSubmitted ? (
        <>
          <Sub>해석이 도움이 됐나요?</Sub>
          <Stars>
            {[1, 2, 3, 4, 5].map(s => (
              <Star
                key={s}
                onMouseEnter={() => setHover(s)}
                onMouseLeave={() => setHover(0)}
                onClick={() => handleSelect(s)}
                title={`${s}점`}
              >
                {(hover || selected) >= s ? '★' : '☆'}
              </Star>
            ))}
          </Stars>
        </>
      ) : (
        <>
          <ThankMsg>{'★'.repeat(selected)}{'☆'.repeat(5 - selected)}</ThankMsg>

          {hasSaju && sajuHelped === null ? (
            <SajuQuestion>
              <SajuQuestionText>사주 정보가 해석에 도움이 됐나요?</SajuQuestionText>
              <BtnRow>
                <YesNoBtn onClick={() => handleSajuHelped(true)}>도움됨</YesNoBtn>
                <YesNoBtn onClick={() => handleSajuHelped(false)}>별로 없음</YesNoBtn>
              </BtnRow>
            </SajuQuestion>
          ) : (
            <ThankMsg style={{ marginTop: 8 }}>소중한 의견 감사합니다!</ThankMsg>
          )}
        </>
      )}

      <AgainBtn onClick={onReset}>다시 점보기</AgainBtn>
    </Card>
  );
}
